import React from 'react';
import classNames from 'classnames';
import './hamburgers.css';
import './custom.css';

export default function MenuIcon({ isActive }) {
  return (
    <div
      className={classNames('hamburger hamburger--squeeze', {
        'is-active': isActive,
      })}
    >
      <div className='hamburger-box'>
        <div className='hamburger-inner'></div>
      </div>
    </div>
  );
}
